import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BackupReconsTable from '../Backup365ReconsTable'
import { Alert, Button, Card, CardBody } from 'reactstrap'
import { fetchBackupRecons } from '../../actions/backup365ReportsActions'

const BackupReconsTab = () => {
  const dispatch = useDispatch()
  const backupRecons = useSelector((state) => state.backup365Reports.backupRecons)
  const loading = useSelector((state) => state.backup365Reports.loading)
  const loadFailed = useSelector((state) => state.backup365Reports.backupReconsLoadFailed)
  const loadError = useSelector((state) => state.backup365Reports.backupReconsLoadError)

  // Distinguish "fetch failed" (could be a slow query timing out, network blip, 500)
  // from "fetch succeeded but the list is legitimately empty". Previously both rendered
  // the same "No reconciliation data found" message, which was misleading when the real
  // cause was the backend taking too long and the HTTP client aborting.
  if (loadFailed) {
    return (
      <Alert color="warning" className="d-flex align-items-center justify-content-between">
        <div>
          Couldn't load reconciliations.
          {loadError ? <span className="text-muted ms-2">({loadError})</span> : null}
        </div>
        <Button
          size="sm"
          color="warning"
          outline
          disabled={loading}
          onClick={() => dispatch(fetchBackupRecons())}
        >
          {loading ? 'Retrying…' : 'Retry'}
        </Button>
      </Alert>
    )
  }

  if (!backupRecons || backupRecons.length === 0) {
    return <div className="text-muted">No reconciliation data found.</div>
  }

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <BackupReconsTable companies={backupRecons} />
      </CardBody>
    </Card>
  )
}

export default BackupReconsTab
